// Login.jsx (Componente principal)
import React, { memo, useState } from 'react';
import LoginForm from '../../components/Auth/LoginComponents/LoginForm';
import LoginCard from '../../components/Auth/LoginComponents/LoginCard';

const BackgroundDecor = memo(function BackgroundDecor() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute -left-20 -top-16 h-56 w-56 rounded-full bg-red-200/60" />
      <div className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-rose-200/50" />
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="dots" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1.5" fill="#fca5a5" fillOpacity="0.5" />
          </pattern>
        </defs>
        <rect width="600" height="600" fill="url(#dots)" />
      </svg>
    </div>
  );
});

export default function Login() {
  const [loginSuccess, setLoginSuccess] = useState(false);

  const handleLoginSuccess = () => {
    setLoginSuccess(true);
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-50 px-4">
      <BackgroundDecor />

      <div className="relative z-10 flex min-h-screen items-center justify-center py-6">
        <LoginCard loginSuccess={loginSuccess}>
          <LoginForm onLoginSuccess={handleLoginSuccess} />
        </LoginCard>
      </div>
    </div>
  );
}
